export default __webpack_public_path__ + "5fb33bf5b043723290dd083bf499dab1.png";